const BASE = process.env.REACT_APP_DOCUMENT_LINK || "";

const buildUrl = (path: string, params?: Record<string, string | number>) => {
  const url = new URL(`${BASE}${path}`, window.location.origin);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        url.searchParams.set(key, String(value));
      }
    });
  }

  return url.toString();
};

export async function fetchJson<T>(
  path: string,
  params?: Record<string, string | number>,
  init?: RequestInit
): Promise<T> {
  const res = await fetch(buildUrl(path, params), init);

  if (!res.ok) {
    throw new Error(`API error: ${res.status}`);
  }

  return res.json() as Promise<T>;
}

export async function postJson<T>(
  path: string,
  body: unknown,
  init?: RequestInit
): Promise<T> {
  const headers = new Headers(init?.headers || {});
  headers.set("Content-Type", "application/json");

  const res = await fetch(buildUrl(path), {
    method: "POST",
    body: JSON.stringify(body),
    headers,
    ...init,
  });

  if (!res.ok) {
    throw new Error(`API error: ${res.status}`);
  }

  return res.json() as Promise<T>;
}

export const getStreamUrl = (path: string, params?: Record<string, string | number>) =>
  buildUrl(path, params);
